import EquipmentContracts from "./EquipmentContracts";

export default EquipmentContracts;
